import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";
import { getLabelFromBrandstof } from "helpers/constants";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`;

export const BrandstofFilter = ({ condensed }) => {
    const filter = useFilter("brandstofsoort");
    const count = useCount("brandstofsoort");
    const [value, , onChange] = useField("brandstofsoorten");

    const options =
        filter.map((option) => ({
            id: option,
            displayName: getLabelFromBrandstof(option),
            aantal: count[option]
        })) || [];

    return (
        <Grid>
            <FilterCheckList
                filterId="filter-brandstof"
                dataTestId="filter-brandstof"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                columns={condensed ? 1 : 5}
                datalayerKey="brandstofsoort"
                maxSize={0}
            />
        </Grid>
    );
};
